export const customer = {
  // Customer Dashboard
  totalBookings: 'إجمالي الحجوزات',
  noBookingsYet: 'لا توجد حجوزات بعد',
  startExploring: 'ابدأ في استكشاف سياراتنا لعمل حجزك الأول!',
  recentBookings: 'الحجوزات الأخيرة',
  viewDetails: 'عرض التفاصيل',
  bookNewCar: 'احجز سيارة جديدة',
}; 